(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/matchevents/assets/javascripts/views/statmatchevents.js') >= 0) return;  svs.modules.push('/components/statistics/matchevents/assets/javascripts/views/statmatchevents.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.moq = svs.statistics.moq || {};
  svs.statistics.data = svs.statistics.data || {};

  var log = new svs.core.log.Logger('svs.statistics.views.StatMatchEvents'),
    numberOfBetradarAttempts = 10,
    betradarAttemptsSoFar = 0;

  svs.statistics.views.StatMatchEvents = svs.statistics.views.SportserviceTabBase.extend(
    {
      tagName: 'div',

      classId: 'StatMatchEvents',

      viewId: 'matchinfo',

      events: {},

      isStatLoaded: false,

      initialize: function(options) {
        this.options = options;
        if (!this.options.params.matchId) {
          return;
        }

        if (options) {
          svs.statistics.views.SportserviceTabBase.prototype.initialize.apply(
            this,
            [options]
          );
        }

        this.model = new svs.statistics.models.statMatchEvents({
          urlParams: { id: this.options.params.matchId },
          observer: this,
          parentId: this.options.params.parentId,
          drawNumber: this.options.params.drawNumber
        });
        this.observer = options.params.parent;

        this.listenTo(this.model, 'change', this.render);
        this.listenTo(this.model, 'sync', this.setupOdds);
        this.listenTo(this.observer, 'initHandler', this.initHandler);
        this.listenTo(this.observer, 'closeHandler', this.closeHandler);

        this.model.on('fetchError', this.handleFetchError, this);

        this.setupOdds();

        if (_.isObject(svs.statistics.moq.StatMatchEventMock)) {
          this.statMatchEventMock = new svs.statistics.moq.StatMatchEventMock({
            modelReference: this.model,
            options: options,
            ref: this
          });
        }
      },

      initHandler: function(e) {
        if (e.currentView.id !== this.viewId) {
          return;
        }
        this.startPush();
      },

      setupOdds: function() {
        if (
          this.model &&
          _.isObject(this.model.get('events')) &&
          this.model.oddsInfo
        ) {
          this.stopListening(this.model, 'sync');

          this.odds = new svs.statistics.models.Odds({
            matchId: this.model.get('events').matchId,
            subscribe: true,
            fetch: false,
            oddsInfo: this.model.oddsInfo
          });
          this.odds.on('change', this.updateOdds, this);
        }
      },

      startPush: function() {
        if (this.statMatchEventMock) {
          this.statMatchEventMock.startPush();
        } else {
          var getInitialData = true;
          if (this.model) this.model.startPush(getInitialData);
        }
      },

      handleFetchError: function() {
        var _self = this;
        _self.$el.html(svs.statistics.statistics.templates.tryagain({}));
        _self.$('.js-statistics-reload').bind('click', function() {
          $(this).unbind('click');
          _self.model.fetch({
            error: function() {
              _self.handleFetchError();
            }
          });
        });
      },

      closeHandler: function() {
        if (this.statMatchEventMock) {
          this.statMatchEventMock.stopPush();
        }
      },

      updateOdds: function() {
        if (this.model) {
          if (_.isObject(this.model.get('events'))) {
            this.model.get('events').odds = this.odds.get('odds'); 
            this.model.get('events').favourite = this.odds.getFavourite();
            this.model.parse(this.model.toJSON());
          }
        }
      },

      update: function() {
        log.debug('update view');

        var _self = this;

        if (svs.statistics.data.content) {
          this.model.set(svs.statistics.data.content);
          svs.statistics.data.content = null; 
        } else {
          this.model.fetch({
            error: function() {
              _self.$el.html(svs.statistics.statistics.templates.tryagain({}));
              _self.$('.js-statistics-reload').bind('click', function() {
                $(this).unbind('click');
                _self.update();
              });
            },
            success: function() {
              _self.model.set('fetched', true);
            }
          });
        }
        if (this.model.get('fetched')) {
          this.model.startPush(false);
        }
      },

      createTTNews: function() {
        if (!this.ttnewsView) {
          this.ttnewsView = new svs.statistics.newstt.views.NewsTTList({
            params: {
              parentId: 'svs-workarea-articles-newstt',
              domainCategories:
                'svs-domain-sport-events/' + this.model.get('events').matchId,
              numOfArticles: 1,
              displayMode: 'integrated',
              className: 'grid-row',
              useTabletGradient: !svs.core.detect.formfactor.mobile(),
              DOMHolderRef: '#news-tt',
              header: 'Senaste från TT'
            }
          });
          this.listenTo(this.ttnewsView, 'news:navigate', this.navigateToTab);
          this.listenTo(this.ttnewsView, 'render', this.setTTNewsVisibility);
        }

        this.$el.find('#news-tt').append(this.ttnewsView.render().el);
      },

      setTTNewsVisibility: function(options) {
        if (options.$el.text()) {
          this.$el.find('#news-tt').removeClass('hide-news-tt');
        }
      },

      navigateToTab: function(args) {
        this.observer.trigger('navigate-tab', args);
      },

      renderWithData: function() {
        if (
          !this.model ||
          !this.model.get('events') ||
          (this.model.get('error') && !this.model.get('fetched'))
        ) {
          if (_.isObject(this.model) && !this.model.get('pending')) {
            this.$el.html(svs.statistics.statistics.templates.nodata({}));
          }

          return this;
        }

        var _self = this,
          componentFile = 'stat-match-events',
          id =
            this.model.attributes.events.league.sport.id ||
            this.model.attributes.events.league.sport,
          theme;

        theme = new svs.sport.themeLoader({
          sport: id
        });
        theme.load(function(template, init) {
          if (!template) {
            return _self.$el.html(
              svs.statistics.statistics.templates.nodata({})
            );
          }
          _self.template = template;

          var srLiveEl = _self.$el.find('.js-live-match-tracker').detach();

          _self.$el.html(_self.template(_self.model.toJSON()));
          _self.createTTNews();

          if (
            srLiveEl.length > 0 &&
            _self.$el.find('.js-live-match-tracker').length > 0
          ) {
            _self.$el.find('.js-live-match-tracker').replaceWith(srLiveEl);
          }
          if (
            Object.prototype.hasOwnProperty.call(_self.options.params, 'parent')
          ) {
            _self.options.params.parent.trigger('resize');
          }
          if (init) {
            init(componentFile);
          }

          var betRadarId = parseInt(_self.model.get('betRadarId'), 10);
          if (
            _self.model.get('hasStarted') &&
            !!betRadarId &&
            _self.model.get('isLive')
          ) {
            if (!_self.isStatLoaded) {
              if (_self._showPlaceholder()) {
                _self._renderLmtPlaceholder(betRadarId);
              } else {
                _self.widgetID = loadBetradar(
                  _self.$el,
                  betRadarId,
                  _self.model.get('isLive'),
                  loadBetradar
                );
              }
              _self.isStatLoaded = true;
            }
          } else {
            _self.$el.find('.js-live-match-tracker').remove();
          }
        }, componentFile);
        return this;
      },

      _renderLmtPlaceholder: function(betRadarId) {
        var _self = this,
          $imgPlaceholder = $('<img />')
            .attr(
              'src',
              svs.core.config.data.svsconfig.cdn +
                '/images/statistics/matchevents/' +
                getPlaceholderImage.call(this) +
                '-ver3.jpg'
            )
            .css('display', 'block')
            .attr(
              'alt',
              'Platshållare för livematchtracker, använd play-knappen för att starta'
            ),
          $btnPanel = $('<div />').addClass('lmt-placeholder-btn-panel'),
          $playBtn = $('<div />')
            .addClass('lmt-placeholder-play-btn icon-default icon-play-circle')
            .attr('role', 'button')
            .attr('tabindex', '0'),
          $lmt = this.$el.find('.js-live-match-tracker');

        function getPlaceholderImage() {
          var groundType = this.model.get('groundType'),
            sport = this._getSports()[this.model.get('sport').id],
            suffix = '';

          if (!groundType && Array.isArray(sport.ground)) {
            groundType = sport.ground[0];
          }

          if (groundType) {
            suffix = '-' + groundType;
          }

          return sport.type + suffix;
        }

        $lmt
          .find('.lmts-container')
          .addClass('lmt-placeholder')
          .append($imgPlaceholder);


        $playBtn.one('click touch', function clickLoadBetradar(evt) {
          evt.stopPropagation();
          _self.widgetID = loadBetradar(
            _self.$el,
            betRadarId,
            _self.model.get('isLive'),
            loadBetradar
          );
        });

        $imgPlaceholder.one('load', function() {
          $lmt.css('min-height', $lmt[0].getBoundingClientRect().height);
          $imgPlaceholder.after($btnPanel.append($playBtn));
        });

        $imgPlaceholder.one('error', function() {
          _self.widgetID = loadBetradar(
            _self.$el,
            betRadarId,
            _self.model.get('isLive'),
            loadBetradar
          );
        });
      },

      _isSportWithPlaceholder: function() {
        var sports = this._getSports(),
          sportId = this.model.get('sport').id + '';
        return Object.keys(sports).indexOf(sportId) >= 0;
      },

      _getSports: function() {
        var sports = {};
        sports[svs.statistics.constants.SOCCER] = {
          type: 'soccer'
        };
        sports[svs.statistics.constants.HOCKEY] = {
          type: 'hockey'
        };
        sports[svs.statistics.constants.TENNIS] = {
          type: 'tennis',
          ground: [
            svs.statistics.constants.HARDCOURT,
            svs.statistics.constants.GRASS,
            svs.statistics.constants.GRAVEL
          ]
        };
        return sports;
      },

      _showPlaceholder: function() {
        return (
          svs.core.detect.formfactor.mobile() &&
          this.model.get('isLive') &&
          this._isSportWithPlaceholder()
        );
      },

      onBeforeDestroy: function() {
        if (Object.prototype.hasOwnProperty.call(window, 'SIR')) {
          SIR('removeWidget', this.$el.find('.js-live-match-tracker')[0]);
        }
      },

      onDestroy: function() {
        this.closeHandler();
        this.stopListening();
        if (this.model) {
          this.model.dispose();
        }

        if (this.observer) {
          this.observer.off();
          this.observer.stopListening();
          this.observer = null;
        }

        if (this.ttnewsView) {
          _.invoke([this.ttnewsView], 'destroy');
          this.ttnewsView = null;
          delete this.ttnewsView;
        }

        delete this.observer;
        delete this.options.params.parent;

        delete this.$el;
        delete this.el;
      }
    }
  );

  function loadBetradar($el, betRadarId, isLive, callback) {
    if (!betRadarId) {
      return;
    } else if (
      !Object.prototype.hasOwnProperty.call(window, 'SIR') &&
      betradarAttemptsSoFar === 0
    ) {
      $el
        .find('.lmts-container')
        .append('<div class="live-tracker-loader"></div>');
      var loop = setInterval(function() {
          if (
            Object.prototype.hasOwnProperty.call(window, 'SIR') ||
            betradarAttemptsSoFar > numberOfBetradarAttempts
          ) {
            callback($el, betRadarId, isLive, callback);
            clearInterval(loop);
            loader.hide();
            loader = null;
            $el.find('.lmts-container').remove('.live-tracker-loader');
          } else {
            betradarAttemptsSoFar++;
          }
        }, 500),
        loader = new svs.components.Loader(
          $el.find('.live-tracker-loader')
        ).show(200);
      _.defer(function() {
        $el.find('.live-tracker-loader').addClass('live-tracker-loader-fix');
      });
      return;
    } else if (!Object.prototype.hasOwnProperty.call(window, 'SIR')) {
      $el.find('.js-live-match-tracker').addClass('lmts-wrapper-hide');
      return;
    }
    SIR(
      'addWidget',
      $el.find('.js-live-match-tracker')[0],
      'match.lmt',
      {
        adsFrequency: false,
        showOdds: false,
        disableEventStats: true,
        disableFooterStats: true,
        disablePitchNoise: false,
        disablePitchStripes: false,
        disablePitchSpotlights: false,
        goalBannerImage:
          svs.core.config.data.svsconfig.cdn +
          '/images/statistics/matchevents/svs-logo.png',
        goalBannerCustomBgColor: '#ffffff',
        matchId: svs.utils.url.queryString.match || betRadarId
      },
      function() {
        if (isLive) {
          $el
            .find('.js-live-match-tracker')
            .one('DOMSubtreeModified', function() {
              $el.find(this).css('min-height', '0px');
            });
        }
      }
    );

    $(document).bind('DOMSubtreeModified', function() {
      var betRadarCarousel = $('.sr-lmt-matchstatus__slider');
      if (betRadarCarousel.length) {
        betRadarCarousel.addClass('rsNoDrag');
        $(document).unbind('DOMSubtreeModified');
      }
    });

    return null;
  }
})(Backbone, _, svs);

 })(window);